import type { FaireProductEntity } from "../../entity_types/product";

export const p_f82cch2k37: FaireProductEntity = {
  token: "p_f82cch2k37",
  type: "product",
  name: "Poppy Multicolor Acrylic Hoops",
  brandToken: "b_2vp3ue16",
  brandName: "Nikki Smith Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/7745e27098f25cde7dbbbeeabbb3c9948eeac2dd4491421b5bc6886cbf297b61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a04afb272c30b6fa9a0d11e5737e40038868dc176afd1c860059ca7a09838d97.jpeg",
    "https://cdn.faire.com/fastly/5e7a0ff3c0e17b14735363e0b1c34c740658d59cd3599614222b8ea839652edd.jpeg",
    "https://cdn.faire.com/fastly/90724bb64720129ececeb9e033f53cbe012f165570abba0234de7a1603c631d0.jpeg",
  ],
  priceDollars: 15,
  description:
    "These new hoops are perfectly on trend for spring and summer. We guarantee your customers are going to love these!\n14k Gold Plated Hoops with colorful acrylic overlay",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:45.217Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
